/**
 *  此文件是专门给黑箱扩展vue模块路由用的，
 *  达到不影响主工程的路由文件升级目的
 * */
const blackBoxRouter = () => {
    return [];
};
export default blackBoxRouter;
